import React from 'react';
import PropTypes from 'prop-types';
import styles from '../../node_modules/@flixbus/honeycomb/assets/scss/components/_label.js';
import HoneyBem from '../../packages/honey-bem/honey-bem.js';
import { Injecss } from '../../packages/injecss/injecss.js';

var Label = function Label(_ref) {
  var text = _ref.text,
      labelFor = _ref.labelFor,
      extraClasses = _ref.extraClasses,
      requiredText = _ref.requiredText;
  // defines base block class name for the input
  var bem = HoneyBem('label', styles); // stores BEM class names, defines BEM modifiers

  var labelText = requiredText ? "".concat(text, " (").concat(requiredText, ")") : text;
  return React.createElement("label", {
    className: bem.b(false, extraClasses),
    htmlFor: labelFor
  }, labelText);
};
Label.displayName = 'Label';
Label.defaultProps = {
  extraClasses: '',
  labelFor: null,
  requiredText: null
};
Label.propTypes = {
  /** Text for a label */
  text: PropTypes.string.isRequired,

  /** Specifies for attribute, should have an ID of associated input */
  // @todo this needs to be required for a11y purposes,
  // reconsider approach in SelectGroup and TimeInput components
  labelFor: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /** Marks the element as required, adds specified text to label text,
   * e.g. Phone (Mandatory) for required="(Mandatory)" */
  requiredText: PropTypes.string,

  /** Custom classes name for tooltip element */
  extraClasses: PropTypes.string
};
var Label$1 = Injecss(Label, styles);

export default Label$1;
export { Label };
